// extracted by mini-css-extract-plugin
export default {"desktopNav":"desktopNav__Mzc2Y","navLeft":"navLeft__NTFjY","navRight":"navRight__ODk2N","navLogoLink":"navLogoLink__YzhkZ","navItems":"navItems__NDk1N","navItem":"navItem__ODQzO"};